
export interface ImageCompressionOptions {
  maxWidth?: number;
  maxHeight?: number;
  quality?: number; 
  format?: 'image/png' | 'image/jpeg' | 'image/webp';
}

export async function compressImage(
  imageDataURL: string, 
  options: ImageCompressionOptions = {}
): Promise<string> {
  const {
    maxWidth = 800,
    maxHeight = 1000, 
    quality = 0.8,
    format = 'image/png'
  } = options;

  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx) {
        reject(new Error('Não foi possível obter contexto do canvas'));
        return;
      }

      
      let { width, height } = img;
      
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      
      if (height > maxHeight) {
        width = (width * maxHeight) / height;
        height = maxHeight;
      }

      
      canvas.width = width;
      canvas.height = height;

      
      ctx.fillStyle = '#FFFFFF'; 
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      
      const compressedDataURL = canvas.toDataURL(format, quality);
      
                              resolve(compressedDataURL);
    };

    img.onerror = () => {
      reject(new Error('Erro ao carregar imagem para compressão'));
    };

    img.src = imageDataURL;
  });
}

export function validateImageSize(imageDataURL: string): {
  isValid: boolean;
  size: number;
  sizeInMB: number;
  message?: string;
} {
  const size = imageDataURL.length;
  const sizeInMB = size / (1024 * 1024);
  
  
  const maxSizeInMB = 10;
  
  if (sizeInMB > maxSizeInMB) {
    return {
      isValid: false,
      size,
      sizeInMB,
      message: `Imagem muito grande (${sizeInMB.toFixed(2)}MB). Máximo permitido: ${maxSizeInMB}MB`
    };
  }
  
  return {
    isValid: true,
    size,
    sizeInMB
  };
}

export async function prepareImageForUpload(
  imageDataURL: string,
  fileName: string
): Promise<{
  optimizedDataURL: string;
  finalFileName: string;
  compressionApplied: boolean;
}> {
    
  const validation = validateImageSize(imageDataURL);
    let optimizedDataURL = imageDataURL;
  let compressionApplied = false;
  
  
  if (validation.sizeInMB > 2) { 
        try {
      optimizedDataURL = await compressImage(imageDataURL, {
        maxWidth: 800,
        maxHeight: 1000,
        quality: 0.85,
        format: 'image/png'
      });
      compressionApplied = true;
      
      
      const compressedValidation = validateImageSize(optimizedDataURL);
          } catch (error) {
            optimizedDataURL = imageDataURL;
    }
  }
  
  
  let finalFileName = fileName;
  if (!finalFileName.toLowerCase().endsWith('.png')) {
    finalFileName = fileName.replace(/\.[^.]*$/, '') + '.png';
  }
  
  return {
    optimizedDataURL,
    finalFileName,
    compressionApplied
  };
}
